import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from "react-router-dom"
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { forumQueries } from '../../graphql/queries'
import { forumMutations } from '../../graphql/mutations'
import Select from '@material-ui/core/Select'
import CKEditor from 'ckeditor4-react'
import { useSnackbar } from 'notistack'
import ckeditorConfig from '../../utils/ckeditor'
import { FormHelperText } from '@material-ui/core'
import { userQueries } from '../../graphql/queries'
import PriorityHighTwoToneIcon from '@material-ui/icons/PriorityHighTwoTone';


export default function AlertDialog({ open, handleClose, query, courseId, cursoId, category }) {
  let didRemoveAllTabIndexes = false //eslint-disable-line
  let intervalKey = false

  const { data: dataCategoriasForum } = useQuery(forumQueries.GET_FORUM_CATEGORIES, { variables: { curso_id: cursoId } })
  const [formErrors, setFormErrors] = useState({ touched: false, fields: { titulo: true, descricao: true, categoria_id: true }, valid: false })
  const { enqueueSnackbar } = useSnackbar()
  const [trails, setTrails] = useState([])
  const [categoriaId, setCategoriaId] = useState(null)
  const [trailsStep, setTrailsStep] = useState([])
  const [apelido, setApelido] = useState(false)

  const [filter, setFilter] = useState({ curso_id: '', categoria_id: '', subcategoria_id: '' })

  const currentCourse = ((dataCategoriasForum || []).categoriasForum || []).find(row => row._id === cursoId)

  const currentCategory = ((currentCourse || []).trilhas || []).find(item => item.items.find(row => row._id === category))

  const currentSubcategory = ((currentCategory || {}).items || []).find(item => item._id === category)

  var defaultResource = {
    titulo: '',
    descricao: '',
    categoria_id: category,
    curso_id: cursoId ? cursoId : courseId
  }

  useEffect(() => {
    setTrails((currentCourse || []).trilhas)
    setTrailsStep(currentCategory)
    setCategoriaId((currentSubcategory || [])._id)
    setResource({ ...defaultResource, categoria_id: category })
    setFilter({ curso_id: (currentCourse || {})._id, categoria_id: (currentCategory || {}).titulo, subcategoria_id: (currentSubcategory || {})._id })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCourse, currentCategory, currentSubcategory, category])

  const [resource, setResource] = useState({ ...defaultResource })

  let history = useHistory()
  const routeChange = () =>{    
    history.push("/meu-perfil")
  } 
  const { loadingUser, data: dataUser, refetch } = useQuery(userQueries.GET_USER)



  
  const [adicionaTopicoForum, { loading }] = useMutation(forumMutations.ADD_NEW_FORUM_TOPIC, {
    refetchQueries: [query],
    onCompleted() {
      handleClose()
      enqueueSnackbar('Tópico criado com sucesso!')
      setResource({ ...defaultResource })
    }
  })

  const filterTrailsByCourse = course => {
    if (course === 'Geral') {
      setResource({ ...defaultResource, curso_id: null, categoria_id: 'all' })
    } else {
      setResource({ ...defaultResource, curso_id: course })
    }

    var trailsToList = ((dataCategoriasForum || []).categoriasForum || []).find(row => row._id === course)

    var obj = {}

    const trilhas = (trailsToList || []).trilhas

    if (trilhas) {
      for (var i = 0, len = trilhas.length; i < len; i++) {
        obj[trilhas[i].titulo] = trilhas[i]
      }
    }

    trailsToList = []

    for (var key in obj) {
      trailsToList.push(obj[key])
    }

    setTrails(trailsToList)
  }

  const filterTrailsStepByTrailTitle = cat => {
    const trailsStepToList = (trails || []).find(row => row.titulo === cat)

    setTrailsStep(trailsStepToList)
  }

  const getCategorieId = subcat => {
    if (!subcat) {
      setResource({ ...resource, categoria_id: 'all' })
    } else {
      setResource({ ...resource, categoria_id: categoriaId || subcat })
    }
  }

  const removeAllTabIndexes = () => {
    const $editDocumentModal = document.getElementById('dialog-modal')
    if ($editDocumentModal) {
      const $allDivs = $editDocumentModal.querySelectorAll('div')
      for (let $div of $allDivs) {
        $div.removeAttribute('tabindex')
      }
      didRemoveAllTabIndexes = true
      clearInterval(intervalKey)
    }
  }

  const handleChangeResource = e => {
    setResource({ ...resource, [e.target.name]: e.target.value })
    setFormErrors({
      ...formErrors,
      fields: {
        ...formErrors.fields,
        [e.target.name]: !e.target.value
      }
    })
  }
  useEffect(() => {
    if (open) {
      setFormErrors({ touched: false, fields: { titulo: true, descricao: true, categoria_id: true } })
    }
  }, [open])

  useEffect(() => {
    removeAllTabIndexes()
  })

  const handleSubmit = useCallback(
    e => {
      e.preventDefault()
      const newFormError = {
        ...formErrors,
        fields: {
          ...formErrors.fields,
          titulo: !resource.titulo,
          descricao: !resource.descricao,
          categoria_id: !resource.categoria_id
        },
        touched: true
      }
      setFormErrors(newFormError)

      const formValid = !Object.values(newFormError.fields).find(item => !!item)

      if (formValid) {
        enqueueSnackbar('Tópico criado com sucesso!')
        adicionaTopicoForum({ variables: { ...resource, modulo_id: courseId } })
      } else {
        enqueueSnackbar('Campos inválidos')
      }
    },
    [resource, enqueueSnackbar, adicionaTopicoForum, courseId, formErrors]
  ) //eslint-disable-line

function perfil(data){
  if(data.dataUser){
    let apel = data.dataUser.usuario.apelido
   
    if(apel && apel != null & apel != 'None' ) return true
    return false 
  }
}

  if (loadingUser) {return ''} 
  else{
    let findNick = perfil({dataUser})

    if(!findNick ){
      return (
        <div>
            <Dialog id="dialog-modal" open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
              <DialogTitle id="alert-dialog-title">{'Apelido não cadastrado!'}</DialogTitle>
                <DialogContent>
                   <DialogContentText style={{textAlign: 'center'}}  id="alert-dialog-description">
                       <PriorityHighTwoToneIcon style={{color: 'red'}}  fontSize="large"/>
                       <br/>
                       <p>Atualize seu perfil para criar um tópico.</p>
                      <Button color="primary" className="px-4"onClick={routeChange} >
                          Acesse aqui para atualizar
                      </Button>
                  </DialogContentText>
              </DialogContent>
            </Dialog>
          </div>
       
      )
    }
  }
 
  return (
    <div>
      <Dialog id="dialog-modal" open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{'Criar um tópico'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">

           {!loadingUser? perfil({dataUser}): ''}


            <form id={'form_form'} onSubmit={handleSubmit}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="demo-simple-select-helper-label">Módulo</InputLabel>
                <Select label="Módulo" value={filter.curso_id} onChange={e => filterTrailsByCourse(e.target.value)}>
                  {((dataCategoriasForum || []).categoriasForum || []).map(item => {
                    return (
                      <MenuItem key={item._id || item.titulo} value={item._id || item.titulo}>
                        {item.titulo}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>

              <FormControl
                error={formErrors.touched && formErrors.fields['categoria_id']}
                disabled={(trails || {}).length === 0 ? true : false}
                variant="outlined"
                fullWidth
              >
                <InputLabel id="demo-simple-select-helper-label">Categoria</InputLabel>
                <Select
                  label="Categoria"
                  placeholder={'Categoria'}
                  value={filter.categoria_id}
                  defaultValue={'Geral'}
                  onChange={e => filterTrailsStepByTrailTitle(e.target.value)}
                >
                  <MenuItem key={null} value={'Geral'}>
                    Geral
                  </MenuItem>
                  {(trails || []).map(trilha => {
                    return (
                      <MenuItem key={trilha.titulo} value={trilha.titulo}>
                        {trilha.titulo}
                      </MenuItem>
                    )
                  })}
                </Select>
                {formErrors.touched && formErrors.fields['categoria_id'] && <FormHelperText error={true}>Campo obrigatório</FormHelperText>}
              </FormControl>
              {((trailsStep || []).items || []).length !== 0 && (
                <FormControl
                  error={formErrors.touched && formErrors.fields['categoria_id']}
                  disabled={((trailsStep || []).items || []).length === 0 ? true : false}
                  variant="outlined"
                  fullWidth
                >
                  <InputLabel id="demo-simple-select-helper-label">Subcategoria</InputLabel>
                  <Select label="Subcategoria" value={filter.subcategoria_id} onChange={e => getCategorieId(e.target.value)}>
                    {((trailsStep || []).items || []).map(step => {
                      return (
                        <MenuItem key={step._id} value={step._id}>
                          {step.titulo}
                        </MenuItem>
                      )
                    })}
                  </Select>
                  {formErrors.touched && formErrors.fields['categoria_id'] && <FormHelperText error={true}>Campo obrigatório</FormHelperText>}
                </FormControl>
              )}

              <TextField
                id="outlined-full-width"
                label="Título"
                error={formErrors.touched && formErrors.fields['titulo']}
                placeholder="Título"
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                variant="outlined"
                onChange={handleChangeResource}
                name="titulo"
                helperText={formErrors.touched && formErrors.fields['titulo'] ? 'Campo obrigatório' : ''}
                value={resource.titulo}
              />
              <FormControl error={formErrors.touched && formErrors.fields['descricao']} style={{ width: '100%', zIndex: 3 }}>
                <CKEditor
                  id="field-detalhes-aula"
                  style={{ border: formErrors.touched && formErrors.fields['descricao'] ? '1px solid red' : '1px solid #ddd' }}
                  data={resource.descricao.replace(/<math>|<\/math>/gi, '`')}
                  config={ckeditorConfig}
                  onChange={(event, editor) => {
                    setResource({ ...resource, descricao: event.editor.getData() })
                    setFormErrors({
                      ...formErrors,
                      fields: {
                        ...formErrors.fields,
                        descricao: !event.editor.getData()
                      }
                    })
                  }}
                />
                {formErrors.touched && formErrors.fields['descricao'] && <FormHelperText error={true}>Campo obrigatório</FormHelperText>}
              </FormControl>
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose()
              setResource({ ...defaultResource })
            }}
            color="primary"
          >
            Cancelar
          </Button>
          <Button disabled={loading} color="primary" type={'submit'} form="form_form" autoFocus>
            {!loading ? 'Publicar' : 'Carregando...'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
